import { PatentWipo } from "./patent-wipo";
export default PatentWipo;
